export function AgenticBrowsingPassScore({
  passCount,
  totalCount,
  label = "Agentic Browsing",
  size = "md",
}) {
  if (totalCount == null || totalCount === 0) return null;

  const allPass = passCount === totalCount;
  const dims = {
    md: { box: "w-28 h-28 sm:w-32 sm:h-32", pill: "text-lg", label: "text-xs sm:text-sm" },
    xs: { box: "w-[4.25rem] h-[4.25rem] sm:w-20 sm:h-20", pill: "text-sm sm:text-base", label: "text-[10px] sm:text-xs" },
  }[size] || { box: "w-28 h-28", pill: "text-lg", label: "text-xs sm:text-sm" };

  return (
    <div className="flex flex-col items-center gap-2">
      <div className={`relative flex items-center justify-center ${dims.box}`}>
        <div
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 ${
            allPass ? "bg-green-100" : "bg-amber-100"
          }`}
        >
          <span
            className={`h-2 w-2 rounded-full shrink-0 ${
              allPass ? "bg-green-600" : "bg-amber-600"
            }`}
          />
          <span
            className={`font-semibold tabular-nums ${dims.pill} ${
              allPass ? "text-green-800" : "text-amber-800"
            }`}
          >
            {passCount}/{totalCount}
          </span>
        </div>
      </div>
      <span
        className={`font-medium text-muted-foreground text-center leading-tight px-0.5 ${dims.label}`}
      >
        {label}
      </span>
    </div>
  );
}
